import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import ajaxStationSales from "../../util/remote/ajaxStationSales";
const ViewStationRecentSalesComponent = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [days, setDays] = useState(30);
  // Fetch Sales
  const fetchSales = async () => {
    setLoading(true);
    const data = {
      station_id: station_idd, // assuming the user belongs to a station
      page,
      items_per_page: itemsPerPage,
      days,
    };
    const response = await ajaxStationSales.recent_sales(data);
    setSalesList([]);
    setMeta([]);
    if (response.status === "OK") {
      setSalesList(response.details.list || []);
      setMeta(response.details.meta?.list_of_pages || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSales();
  }, [page, itemsPerPage, days]);
  // Helpers for formatting numbers
  const formatNumber = (num) => {
    if (!num) return "0";
    return Number(num).toLocaleString();
  };
  return (
    <div className="container-fluid">
      <Toaster />
      {/* Loading / No Data */}
      {loading ? (
        <div className="text-center my-5 fs-5 text-muted">Loading Sales...</div>
      ) : salesList.length === 0 ? (
        <div className="text-center my-5 fs-5 text-muted">No Sales Found</div>
      ) : (
        <>
          {/* Table View */}
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <div>
                    <h6 className="card-title mb-1">Recent Fuel Sales</h6>
                    <p className="text-muted card-sub-title">
                      List of recent sales
                    </p>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fuel Type</th>
                          {/* <th>Station</th> */}
                          <th>Quantity (L)</th>
                          <th>Selling Price</th>
                          <th>Total Amount</th>
                          <th>Attendant</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {salesList.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.fuel_category}</td>
                            {/* <td>{item.station_name}</td> */}
                            <td> {formatNumber(item.quantity)}</td>
                            <td>UGX {formatNumber(item.selling_price)}</td>
                            <td>UGX {formatNumber(item.Amount)}</td>
                            <td>
                              {item.first_name} {item.last_name}
                            </td>
                            <td>{item.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ViewStationRecentSalesComponent;
